import { gql } from "@apollo/client";

const minimalMissionRoleFields = `
  slug
  name
  mission {
    uuid
    name
  }
`;

const commonMissionRoleFields = `
  uuid
  name
  domain {
    id
  }
  assessmentId
  description
  descriptionJson
  disciplines {
    id
    name
  }
  primarySkills {
    id
    name
  }
  secondarySkills {
    id
    name
  }
  locations {
    id
    name
  }
`;

const challengeFields = `
  challenges {
    id
    name
  }
`;

const applicationStepsFields = `
  applicationSteps {
    name
    required
  }
`;

const filteredChallengeFields = `
  challenges(includeDisabled: $includeDisabledChallenges) {
    id
    name
  }
`;

const publicViewSettingsFields = `
  publicViewSettings {
    videoLink
    videoLinkEnabled
  }
`;

const coreMissionRoleFields = `
  id
  archetype
  slug
  workArrangement
  location
  startDate
  engagementType
  engagementTime
  applicantApplied
  targetRate
  targetRateCurrency
  state
  builderStep
  builderTemplateId
  published
  remoteAnywhere
  applicantsProfileIds
  publishedAt
  assignedTo {
    id
    name
  }
  talentOwner {
    id
    name
  }
  timezone {
    name
    value
  }
  requirements {
    id
    description
    originalValue
  }
  availableRequirements {
    id
    value
    originalValue
    isRemovable
  }
  roleRequirementsQuestion {
    id
    wording
  }
  requirementsLocked
`;

const timestampFields = `
  createdAt
`;

const applicationsCountFields = `
  applicantsCount
  shortlistedCandidatesCount
  interviewedCandidatesCount
  selectedCandidatesCount
  pendingCandidatesCount
`;

const rateRangeFields = `
  rate {
    min
    max
  }
  currency
  frequency
`;

const attachmentFields = `
  id
  url
  name
  uploadedBy {
    lastName
    firstName
  }
`;

const CORE_MISSION_ROLE_FIELDS = gql`
  fragment MissionRoleFields on MissionRole {
    ${coreMissionRoleFields}
    ${commonMissionRoleFields}
    ${publicViewSettingsFields}
    ${timestampFields}
    ${applicationsCountFields}
    ${challengeFields}
    ${applicationStepsFields}
  }
`;

const CORE_MISSION_ROLE_FIELDS_WITH_FILTERED_CHALLENGES = gql`
  fragment MissionRoleFieldsWithFilteredChallenges on MissionRole {
    ${coreMissionRoleFields}
    ${commonMissionRoleFields}
    ${publicViewSettingsFields}
    ${timestampFields}
    ${applicationsCountFields}
    ${filteredChallengeFields}
    ${applicationStepsFields}
  }
`;

const PUBLIC_MISSION_ROLE_FIELDS = gql`
  fragment PublicMissionRoleFields on PublicMissionRole {
    uuid
    slug
    name
    workArrangement
    engagementType
    location
    state
    description
    descriptionJson
    publicViewSettings {
      videoLink
      videoLinkEnabled
    }
    disciplines {
      id
      name
    }
    primarySkills {
      id
      name
    }
    secondarySkills {
      id
      name
    }
    locations {
      id
      name
    }
    challenges {
      id
      name
    }
  }
`;

const MINIMAL_MISSION_ROLE_FIELDS = gql`
  fragment MinimalMissionRoleFields on MissionRole {
    ${minimalMissionRoleFields}
  }
`;

const RATE_RANGE_FIELDS = gql`
  fragment RateRangeFields on RateRange {
    ${rateRangeFields}
  }
`;

const ATTACHMENT_FIELDS = gql`
  fragment AttachmentFields on MissionRoleAttachment {
    ${attachmentFields}
  }
`;

export {
  CORE_MISSION_ROLE_FIELDS,
  CORE_MISSION_ROLE_FIELDS_WITH_FILTERED_CHALLENGES,
  PUBLIC_MISSION_ROLE_FIELDS,
  MINIMAL_MISSION_ROLE_FIELDS,
  RATE_RANGE_FIELDS,
  ATTACHMENT_FIELDS,
};
